import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Document, toDocumentXml } from '../../dataObjects/Document';

export interface ISaveDocumentRequest extends IBaseRequest {
    document: Document;
    data: string;
}

export class SaveDocumentRequest extends BaseRequest implements ISaveDocumentRequest {
    document: Document;
    data: string;
  constructor(server: string, session: string, document: Document, data: string) {
    super(server, session);
    this.document = document;
    this.data = data;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += toDocumentXml(this.document);
    parameters += this.makeNode(this.data, 'data');

    return super.wrapperXml('SaveDocument', parameters);
  }
}
